import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentSbp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 12.0997L12.3936 18.1656V21.8656L9.00397 27.9196L9 12.0997Z",
			fill: "#5B57A2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0302 15.9583L25.2101 14.0093L31.718 14.0032L22.0302 19.9381V15.9583Z",
			fill: "#D90751"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0121 12.064L22.0301 20.095L18.6285 18.0049V6L22.0121 12.064Z",
			fill: "#FAB718"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.718 14.0032L25.2098 14.0093L22.0121 12.064L18.6285 6L31.718 14.0032Z",
			fill: "#ED6F26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0301 27.9532V24.0568L18.6285 22.0064L18.6304 34.0233L22.0301 27.9532Z",
			fill: "#63B22F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.2021 26.0219L12.3934 18.1656L9 12.0997L31.7042 26.014L25.2021 26.0219Z",
			fill: "#1487C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6307 34.0233L22.0299 27.9532L25.2019 26.0219L31.704 26.014L18.6307 34.0233Z",
			fill: "#017F36"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.00397 27.9196L18.6564 22.0067L15.4113 20.0156L12.3936 21.8656L9.00397 27.9196Z",
			fill: "#984995"
		})
	]
});
export default SvgPaymentSbp;
